import { Calculator } from "../Calculator/Calculator.js";
const calculator = new Calculator();
window.calculator = calculator;

import { Primerka } from "../Primerka/Primerka.js";
const primerka = new Primerka();
window.primerka = primerka;
primerka.checkRowSID();
primerka.createSetting();

import { Lead } from "../lead/lead.js";
const lead = new Lead();
window.lead = lead;

import { Catalog } from "../Catalog/Catalog.js";
const catalog = new Catalog();
window.catalog = catalog;
catalog.applyEvents();

const header = document.querySelector(".header");

const appHeights = () => {
	const doc = document.documentElement
	let headerHeight = $('.header').outerHeight();
	let windowHeight = $(window).height();
	doc.style.setProperty('--app-height', windowHeight + "px");
	doc.style.setProperty('--header-height', headerHeight + "px");
}
appHeights();

window.onload = function () {
	appHeights();
};

// test js
// let swipeArea = document.querySelector('.catalog__table')
// let startX, endX

// swipeArea.addEventListener('touchstart', function(event) {
// 	startX = event.touches[0].clientX
// });

// swipeArea.addEventListener('touchend', function(event) {
// 	endX = event.changedTouches[0].clientX
// 	diffX = startX - endX
// 	let p = primerka.get_cookie('catalog_step') ? primerka.get_cookie('catalog_step') : 1
// 	console.log(primerka.get_cookie('catalog_step'))
// 	if (diffX > 0) {
// 		alert('right')
// 		catalog.changePage(p+1)
// 	} else {
// 		alert('left')
// 		if(p > 1)
// 			catalog.changePage(p-1)
// 	}
// })
// end test js

// Calculator
$('input.form__radio-input.visually-hidden.check_delivery').find(function () {
	if ($("input[type=radio][name=calc_del][id=calc_del-1]:checked").is(':checked')) {
		$('.form__item.calculator-form__level.flex_delivery').removeAttr('style')
	}
	else {
		$('.form__item.calculator-form__level.flex_delivery').attr('style', 'display:flex')
	}

	$('input.form__radio-input.visually-hidden.check_delivery').click(function () {
		if ($("input[type=radio][name=calc_del][id=calc_del-1]:checked").is(':checked')) {
			$('.form__item.calculator-form__level.flex_delivery').removeAttr('style')
		}
		else {
			$('.form__item.calculator-form__level.flex_delivery').attr('style', 'display:flex')
		}
	})
})
$('input.form__radio-input.visually-hidden.check_elevator').find(function () {
	if ($("input[type=radio][name=calc_elevator][id=calc_elevator-yes]:checked").is(':checked')) {
		$('.form__item.calculator-form__level.flex_elevator').removeAttr('style')
	}
	else {
		$('.form__item.calculator-form__level.flex_elevator').attr('style', 'display:flex')
	}

	$('input.form__radio-input.visually-hidden.check_elevator').click(function () {
		if ($("input[type=radio][name=calc_elevator][id=calc_elevator-yes]:checked").is(':checked')) {
			$('.form__item.calculator-form__level.flex_elevator').removeAttr('style')
		}
		else {
			$('.form__item.calculator-form__level.flex_elevator').attr('style', 'display:flex')
		}
	})
})

// Burger
$(".header__burger").on("click", function () {
	$("body").toggleClass("no-scroll");
	$(this).toggleClass("active");
	$(".header__popup").toggleClass("active");
});


// priority plus
var inst;
if ($(".js-p-target").length) {
	inst = priorityPlus(document.querySelector('.js-p-target'), {
		innerToggleTemplate: "Ещё",
	});
}


// SUBMENU
$(".header__menu-link--toggler").on("click", function (e) {
	e.preventDefault();
	$(".header__menu-link--toggler").not(this).removeClass("active");
	$(".header__menu-link--toggler").not(this).siblings(".header__menu-submenu").slideUp();
	$(this).toggleClass("active");
	$(this).siblings(".header__menu-submenu").slideToggle();
});


// Resize
$(window).on("resize", function () {
	appHeights();
});


// Scroll
$(window).on("scroll", function () {
	appHeights();
});


// Document click
$(document).on("click", function (e) {
	// HEADER SUBMENEU
	if ($(".header__menu-link--toggler").hasClass("active") && window.matchMedia("(min-width: 1024px)").matches) {
		var callbackPopup = $(".header__menu-link--toggler, .header__menu-submenu");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".header__menu-link--toggler").removeClass("active");
			$(".header__menu-submenu").slideUp();
		};
	}

	// FAQ
	if ($(".faq__item-toggler").hasClass("active")) {
		var callbackPopup = $(".faq__item-toggler, .faq__item-answer");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".faq__item-toggler").removeClass("active");
		};
	}

	// more btn
	if ($(".p-plus__overflow").is(":visible") && typeof inst !== 'undefined') {
		var callbackPopup = $(".p-plus__toggle-btn, .p-plus__overflow");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			inst.setOverflowNavOpen(false);
		};
	}
});


// popups
$(".popup__close, .popup__cancel").on("click", function (e) {
	if($(this).closest(".popup").find('.active').hasClass('popup-fitting__step--2')) {
		primerka.savePoints()
	}
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
	$('.form__mistakes').html('');
	$('.form__mistakes').css('display', 'none');
	$(".popup-fitting__upload-loader").css('display', 'none');
});

$(".popup").on("click", function (e) {
	if($(this).find('.active').hasClass('popup-fitting__step--2')) return
	var callbackPopup = $(".popup__card, .popup__loader")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");
	let form = popup.find('form');
	let attrDataLeadName = $(this).attr('data-leadname');
	let isCalcForm = false;

	if (typeof attrDataLeadName !== typeof undefined && attrDataLeadName !== false) {
		if (attrDataLeadName == 'calc') { 
			isCalcForm = true;
			form.attr('onsubmit', '');
			//let data = JSON.stringify(dataCalcHandler());
			let data = dataCalcHandler();
			isCalcForm = formCalcSubmit(form, data, isCalcForm); //true/false
		}
	}

	if (dataPopupName == 'popup-good') {

		let id = $(this).attr("data-id");
		let name = $(this).find('img').attr('alt');
		let img = $(this).find('img').attr('src').replace(/\/small_/, '/');

		let image = popup[0].querySelector('img.popup-good__image')
		image.setAttribute('src','')
		let loader = popup[0].querySelector('.popup__loader')
		loader.style.display = 'block'
		image.onload = function() {
			loader.style.display = 'none'
		}

		popup.find('.popup-good__title').text(name);
		popup.find('.popup-good__image').attr('src', img);
		popup.find('.popup__card').attr('data-id', id);

		if ($(this).closest('.catalog-item').find('.catalog-item__nav-btn--like').hasClass('active'))
			popup.find('.popup-good__like').addClass('active');
		else
			popup.find('.popup-good__like').removeClass('active');
	}
	if (dataPopupName == 'popup-review') {
		let id = $(this).attr("data-id");
		let img = $(this).find('img').attr('src').replace('/\/small_/', '/');
		let text = $(this).find('.reviews-card__full').html();

		popup.find('.popup-review__blockquote').html(text);
		popup.find('.popup-review__image').attr('src', img);
		popup.find('.popup__card').attr('data-id', id);
	}

	$("body").addClass("no-scroll");
	popup.addClass("active");
});


// SWIPER
var discountsSlider = new Swiper('.discounts-index__slider', {
	slidesPerView: 'auto',
	spaceBetween: 16,
	// loop: true,
	breakpoints: {
		1024: {
			slidesPerView: 3,
			spaceBetween: 16
		},
		1280: {
			slidesPerView: 4,
			spaceBetween: 16
		},
		1440: {
			slidesPerView: 4,
			spaceBetween: 20
		},
		1680: {
			slidesPerView: 4,
			spaceBetween: 24
		},
		1776: {
			slidesPerView: 4,
			spaceBetween: 28
		},
	},
	navigation: {
		nextEl: '.discounts-slider__nav-btn--next',
		prevEl: '.discounts-slider__nav-btn--prev'
	}
});

var reviewsSlider = new Swiper('.reviews-index__slider', {
	slidesPerView: 1,
	spaceBetween: 8,
	// loop: true,
	breakpoints: {
		768: {
			slidesPerView: 2,
			spaceBetween: 12
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 12
		},
		1440: {
			slidesPerView: 3,
			spaceBetween: 16
		},
		1680: {
			slidesPerView: 3,
			spaceBetween: 20
		},
		1776: {
			slidesPerView: 3,
			spaceBetween: 24
		},
	},
	navigation: {
		nextEl: '.reviews-slider__nav-btn--next',
		prevEl: '.reviews-slider__nav-btn--prev'
	}
});

var popupPortolioSlider = new Swiper('.popup-portfolio__slider', {
	slidesPerView: 1,
	navigation: {
		nextEl: '.popup-portfolio__slider-nav-btn--next',
		prevEl: '.popup-portfolio__slider-nav-btn--prev'
	},
	pagination: {
		el: ".popup-portfolio__slider-fraction",
		type: "fraction",
	},
});

$(".portfolio-card__link").on("click", function (e) {
	e.preventDefault();
	popupPortolioSlider.slideTo($(this).parent().index(), 0);
});


// FAQ
$(".faq__item-toggler").on("click", function () {
	$(".faq__item-toggler").not(this).removeClass("active");
	$(this).toggleClass("active");
});


// Catalog all filters
$(".catalog-all__filters-toggler").on("click", function () {
	$(".catalog-all__filters").toggleClass("active");
});

$(".catalog-all__filters-close").on("click", function () {
	$(".catalog-all__filters").removeClass("active");
});

$(".catalog-all__filters").on("click", function (e) {
	if ($(".catalog-all__filters").hasClass("active") && !window.matchMedia("(min-width: 7688px)").matches) {
		var callbackPopup = $(".catalog-all__filters-container, .popup-colors");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".catalog-all__filters").removeClass("active");
		};
	}
})

// data handler from calculator
const dataCalcHandler = () => {
	let calcForm = $('.calculator-form');
	let total = $('.calculator-form__price-value').text();
	let data = calcForm.serializeArray();//get data from calculator form
	data = [...data, {name: 'Общая стоимость', value: `${total}`}];
	data.forEach(item => {
		if (item.value == '') return;
		let inp = calcForm.find('input[name="'+item.name+'"][value="'+item.value+'"]');
		let lbl = inp.siblings('label').text();
		if (lbl) item.label = lbl;
	})
	data = calculator.data(data);
	return data;
}
// form submit (from calculator)
const formCalcSubmit = (form, data, condition) => {
	form.on('submit', (e) => {
		e.preventDefault();
		if (condition) lead.sendZayav4(form, data);
		condition = false;
		return false;
	})
	return condition;
}